import "./TestOrderCreateScreen.scss";
import React, {useCallback, useEffect, useRef, useState} from 'react';
import Grid from "@mui/material/Grid";
import {CommonService} from "../../../shared/services";
import {useNavigate, useSearchParams} from "react-router-dom";
import SelectPatientComponent from "./select-patient/selectPatientComponent";
import {ITimelineItem} from "../../../shared/models/timeline.model";
import _ from "lodash";
import TestOrderAttachmentComponent from "./test-order-attachments/TestOrderAttachmentComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import TestOrderDetailsAddComponent from "./test-order-details-add/testOrderDetailsAddComponent";
import TestOrderBillingDetailsComponent from "./test-order-billing-details/TestOrderBillingDetailsComponent";
import {ImageConfig} from "../../../constants";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";
import TimelineComponent from "../../../shared/components/timeline/timelineComponent";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import CopyComponent from "../../../shared/components/copyComponent/copyComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {IRootReducerState} from "../../../store/reducers";
import commonService from "../../../shared/services/common.service";
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Barcode from 'react-barcode';
import SelectDropdownComponent from "../../../shared/components/core/select-dropdown/SelectDropdownComponent";
import PDFFileForRequisition from "../test-order-details/requisition-pdf-download/RequisitionPdfDownload";

export interface TestOrderCreationScreenProps {

}

const SELECT_PATIENT = 'select_patient';
const TEST_ORDER_DETAILS = 'test_order_details';
const ORDER_ATTACHMENTS = 'order_attachments';
const BILLING_DETAILS = 'billing_details';

const STEPS: ITimelineItem[] = [
    {
        id: SELECT_PATIENT,
        title: "Select Patient",
    },
    {
        id: TEST_ORDER_DETAILS,
        title: "Test Order Details",
    },
    {
        id: ORDER_ATTACHMENTS,
        title: "Attachments",
    },
    {
        id: BILLING_DETAILS,
        title: "Billing Details",
    },
];

const TestOrderCreationScreen = (props: TestOrderCreationScreenProps) => {

        const [steps] = useState<ITimelineItem[]>([..._.cloneDeep(STEPS)]);
        const [searchParams, setSearchParams] = useSearchParams();
        const [currentStep, setCurrentStep] = useState<ITimelineItem | undefined>(STEPS[0]);
        const [testOrderID, setTestOrderID] = useState<number | undefined>(undefined);
        const [activeStep, setActiveStep] = React.useState(0);
        const [testOrderDetails, setTestOrderDetails] = useState<any>(undefined);
        const [isTestOrderDetailsLoading, setIsTestOrderDetailsLoading] = useState<boolean>(false);
        const [isTestOrderStatusDialogOpen, setIsTestOrderStatusDialogOpen] = useState<boolean>(false);
        const [isPlaceOrderLoading, setIsPlaceOrderLoading] = useState<boolean>(false);
        const [isTestOrderSampleListLoading, setIsTestOrderSampleListLoading] = useState<boolean>(false);
        const [isTestOrderSampleListLoadingFailed, setIsTestOrderSampleListLoadingFailed] = useState<boolean>(false);
        const [isTestOrderSampleListLoaded, setIsTestOrderSampleListLoaded] = useState<boolean>(false);
        const locationDetailsForTestOrder = useSelector((state: any) => state.facilityAndLocationDetails.locationDetails);
        const facilityDetailsForTestOrder = useSelector((state: any) => state.facilityAndLocationDetails.facilityDetails);
        const [testOrderSampleList, setTestOrderSampleList] = useState<any[]>([]);
        const [isTestOrderDeleteLoading, setIsTestOrderDeleteLoading] = useState<boolean>(false);
        const [canDiscardTestOrder, setCanDiscardTestOrder] = useState<boolean>(false);
        const [currentBarCode, setCurrentBarCode] = useState<string>("")
        const [labelSize, setLabelSize] = useState<string>("");
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        const navigate = useNavigate();
        const dispatch = useDispatch();

        const printSectionRef = useRef<any>();
        const {LabelConfigurations,LabelOptions}=CommonService._staticData;

        const handlePrint = () => {
            try {
                const printContent = printSectionRef?.current?.innerHTML;

                if (!printContent) {
                    console.error('No content to print');
                    return;
                }

                // Create a new window or iframe for printing
                const printWindow = window.open('', '_blank', 'width=800,height=600');

                if (!printWindow) {
                    console.error('Failed to open print window');
                    return;
                }
                printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Print</title>
                    <style>
                        /* Add any styles needed for printing */
                        @page {
                            margin: 0; /* Remove default margins */
                        }
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 20px;
                        }
                        #print-section {
                              /*border: 1px solid red;*/
                              height: ${LabelConfigurations?.[labelSize]?.height};
                              width: ${LabelConfigurations?.[labelSize]?.width};
                              line-height: ${LabelConfigurations?.[labelSize]?.lineHeight};
                              font-size: ${LabelConfigurations?.[labelSize]?.fontSize};
                        
                              svg {
                                width: 100%;
                                height: auto;
                              }
                        
                              .print-label-value-wrapper{
                                display: flex;
                                align-items: center;
                                  .print-label {
                                    font-weight: bold;
                                  }
                                  .print-value{
                                    flex: 1;
                                    display: inline-block;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                  }
                              }
                        }
                        /* Hide headers and footers */
                        header, footer {
                            display: none;
                        }
                        /* Additional styles if needed */
                    </style>
                </head>
                <body>
                    ${printContent}
                    <script>
                    // Trigger print after content loads
                    window.addEventListener('load', function() {
                        setTimeout(function() {
                            window.print();
                            // Close window after print
                            setTimeout(function() {
                                window.close();
                            }, 100);
                        }, 10);
                    });
                </script>
                </body>
                </html>
            `);
                printWindow.document.close();
                //
                // printWindow.onload = () => {
                //     printWindow.print();
                //     printWindow.close();
                // };
            } catch (error) {
                console.error("An error occurred while printing", error);
            }
        };


        useEffect(() => {
            setCanDiscardTestOrder(commonService.checkAccess('TestOrder', 'testOrderCancel', currentUser?.userAccessModules))
        }, [currentUser])

        useEffect(() => {
            dispatch(setCurrentNavParams("", "Test Order"));
            dispatch(setSideMenuView("compact"));
        }, [dispatch]);

        const updateSteps = useCallback((currentStepIndex: number) => {
            setCurrentStep(STEPS[currentStepIndex]);
            searchParams.set("step", STEPS[currentStepIndex].id);
            setSearchParams(searchParams);
            setActiveStep(currentStepIndex);
        }, [searchParams, setSearchParams]);

        const getTestOrderSampleList = useCallback(() => {
            const payload = {orderId: testOrderID};
            setIsTestOrderSampleListLoading(true);
            setIsTestOrderSampleListLoaded(false);
            setIsTestOrderSampleListLoadingFailed(false);
            let testOrderSampleList: any = [];
            CommonService._testOrder.getTestOrderSampleListLite(payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        testOrderSampleList = response?.data;
                    }
                    setTestOrderSampleList(testOrderSampleList);
                    setIsTestOrderSampleListLoading(false);
                    setIsTestOrderSampleListLoaded(true);
                    setIsTestOrderSampleListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setTestOrderSampleList(testOrderSampleList);
                    setIsTestOrderSampleListLoading(false);
                    setIsTestOrderSampleListLoaded(false);
                    setIsTestOrderSampleListLoadingFailed(true);
                });

        }, [testOrderID]);


        const getTestOrderDetails = useCallback(() => {
            const payload = {isSampleRequired: true};
            let testOrderDetails: any = {};
            setIsTestOrderDetailsLoading(true);
            CommonService._testOrder.getTestOrderDetails(testOrderID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        testOrderDetails = response.data;
                    }
                    setTestOrderDetails(testOrderDetails);
                    setIsTestOrderDetailsLoading(false);
                })
                .catch((error: any) => {
                    setTestOrderDetails(testOrderDetails);
                    setIsTestOrderDetailsLoading(false);
                });
        }, [testOrderID]);

        const placeTestOrder = useCallback((redirect?: boolean) => {
            const payload = {};
            setIsPlaceOrderLoading(true);
            CommonService._testOrder.placeOrder(testOrderID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.success) {
                        redirect && CommonService._alert.showToast(response?.message || "Order placed successfully", "success");
                        redirect && navigate(CommonService._routeConfig.TestOrderListRoute());
                    }
                    setIsPlaceOrderLoading(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || "Failed to place order", "error");
                    setIsPlaceOrderLoading(false);
                });
        }, [testOrderID, navigate]);

        const handlePrevious = useCallback((currentStepIndex: number, currentStepId: string) => {
            if ([ORDER_ATTACHMENTS, BILLING_DETAILS].includes(currentStepId)) {
                updateSteps(currentStepIndex);
            } else {
                // do nothing;
            }
        }, [updateSteps]);

        const handleTestOrderCancel = useCallback(() => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to exit without adding this test order?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Exit",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            }).then(() => {
                navigate(CommonService._routeConfig.TestOrderListRoute());
            }).catch(() => {
                // do nothing;
            });
        }, [navigate]);

        const handleNext = useCallback((currentStepIndex: number, currentStepId: string, testOrderId?: number, data?: any) => {
            switch (currentStepId) {
                case SELECT_PATIENT :
                    if (testOrderId) {
                        setTestOrderID(testOrderId);
                        searchParams.set("testOrderId", testOrderId.toString());
                        setSearchParams(searchParams);
                    }
                    updateSteps(currentStepIndex);
                    break;
                case TEST_ORDER_DETAILS:
                    if (data) {
                        setTestOrderDetails((oldSate: any) => {
                            return {
                                ...oldSate,
                                ...data//set physician id,samples and physician details
                            }
                        });
                    }
                    updateSteps(currentStepIndex);
                    break;
                case ORDER_ATTACHMENTS:
                    updateSteps(currentStepIndex);
                    break;
                case BILLING_DETAILS:
                    getTestOrderSampleList();
                    getTestOrderDetails();//todo:internal state management
                    placeTestOrder();//placing the test order on last step
                    setIsTestOrderStatusDialogOpen(true);
                    break;
                default:
                    <></>
            }
        }, [searchParams, setSearchParams, updateSteps, getTestOrderSampleList, getTestOrderDetails, placeTestOrder]);

        useEffect(() => {
            const step = searchParams.get("step");
            setActiveStep(STEPS.findIndex((stepItem: any) => stepItem.id === step));
            const testOrderId = searchParams.get("testOrderId");
            const stepIDS = STEPS.map(item => item.id);
            let stepIndex = 0;
            if (testOrderId) {
                setTestOrderID(parseInt(testOrderId, 10));
                if (stepIDS.indexOf(step) > -1) {
                    if (step !== SELECT_PATIENT) {
                        stepIndex = stepIDS.indexOf(step);
                    } else {
                        stepIndex = 1;
                    }
                } else {
                    stepIndex = 1;
                }
            } else {
                stepIndex = 0;
                setActiveStep(0)
            }
            setCurrentStep(STEPS[stepIndex]);
        }, [searchParams]);

        const deleteTestOrder = useCallback((testOrderID: any) => {
            const payload = {};
            setIsTestOrderDeleteLoading(true);
            CommonService._testOrder.deleteTestOrder(testOrderID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.success) {
                        setIsTestOrderDeleteLoading(false);
                        CommonService._alert.showToast(response?.message || "Test order deleted successfully", "success");
                        navigate(CommonService._routeConfig.TestOrderListRoute());
                    }
                })
                .catch((error: any) => {
                    setIsTestOrderDeleteLoading(false);
                    CommonService._alert.showToast(error?.error || "Failed to delete test order", "error");
                });
        }, [navigate]);

        const handleTestOrderDelete = useCallback((testOrderID: any) => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to Delete this test order?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.DeleteImage}`,
                direction: "up",
                yes: {
                    text: "Proceed",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            }).then(() => {
                deleteTestOrder(testOrderID);
            }).catch(() => {
                // do nothing;
            });
        }, [deleteTestOrder]);


        const renderComponent = useCallback(() => {
            if (!testOrderID) {
                if (currentStep?.id === SELECT_PATIENT) {
                    return <SelectPatientComponent
                        facilityDetailsForTestOrder={facilityDetailsForTestOrder}
                        locationDetailsForTestOrder={locationDetailsForTestOrder}
                        next={(testOrderId: number) => handleNext(1, SELECT_PATIENT, testOrderId)}
                        cancel={handleTestOrderCancel}
                    />
                }
            } else {
                switch (currentStep && currentStep.id) {
                    case TEST_ORDER_DETAILS:
                        return <TestOrderDetailsAddComponent
                            testOrderID={testOrderID}
                            canDiscardTestOrder={canDiscardTestOrder}
                            testOrderDetails={testOrderDetails}
                            cancel={handleTestOrderCancel}
                            onDelete={() => handleTestOrderDelete(testOrderID)}
                            isDeleteLoading={isTestOrderDeleteLoading}
                            next={(data: number) => handleNext(2, TEST_ORDER_DETAILS, undefined, data)}
                        />
                    case ORDER_ATTACHMENTS:
                        return <TestOrderAttachmentComponent
                            testOrderID={testOrderID}
                            testOrderDetails={testOrderDetails}
                            canDiscardTestOrder={canDiscardTestOrder}
                            cancel={handleTestOrderCancel}
                            onDelete={() => handleTestOrderDelete(testOrderID)}
                            isDeleteLoading={isTestOrderDeleteLoading}
                            next={(data: number) => handleNext(3, ORDER_ATTACHMENTS, undefined, data)}
                            prev={() => handlePrevious(1, ORDER_ATTACHMENTS)}
                        />
                    case BILLING_DETAILS:
                        return <TestOrderBillingDetailsComponent
                            testOrderID={testOrderID}
                            testOrderDetails={testOrderDetails}
                            canDiscardTestOrder={canDiscardTestOrder}
                            cancel={handleTestOrderCancel}
                            onDelete={() => handleTestOrderDelete(testOrderID)}
                            isDeleteLoading={isTestOrderDeleteLoading}
                            next={(data: number) => handleNext(4, BILLING_DETAILS, undefined, data)}
                            prev={() => handlePrevious(2, BILLING_DETAILS)}
                        />
                    default:
                        <></>
                }
            }
        }, [locationDetailsForTestOrder, handleTestOrderDelete, isTestOrderDeleteLoading, testOrderID, facilityDetailsForTestOrder, testOrderDetails, currentStep, handleNext, handlePrevious, handleTestOrderCancel, canDiscardTestOrder]);

        useEffect(() => {
            if (testOrderID) {
                getTestOrderDetails();
            }
        }, [testOrderID, getTestOrderDetails]);

        return (
            <div className="test-order-creation-layout-screen add-layout-with-timeline screen ">
                <Grid container spacing={2} className="add-form-timeline-wrapper">
                    <Grid item sm={12} md={3} xl={3} className="timeline-layout"
                          sx={{
                              display: {sm: "none", md: "block"}
                          }}>
                        <div className="add-layout-title">Creating Test Order</div>
                        <div className="add-layout-timeline">
                            <TimelineComponent
                                activeStep={activeStep}
                                steps={steps}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9} xl={9} className="add-form-content">
                        <div className="add-layout-form-content">
                            {renderComponent()}
                        </div>
                    </Grid>
                </Grid>
                {isTestOrderDetailsLoading &&
                    <div className={"glass-effect h-v-center flex-direction-column"}>
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                <DialogComponent
                    open={isTestOrderStatusDialogOpen}
                    direction={"down"}
                    isShowCancel={false}
                    maxWidth={'sm'}
                    className={"test-order-complete-dialog"}
                >
                    {isTestOrderSampleListLoading &&
                        <div className="h-v-center min-height-auto">
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.LoadingLottieFile}/>
                        </div>
                    }
                    {isTestOrderSampleListLoadingFailed &&
                        <StatusCardComponent title={'Failed to load testorder samples'}/>}

                    {isTestOrderSampleListLoaded &&
                        <div className="test-order-status-confirmation-dialog-container">
                            <div className="test-order-status-confirmation-dialog-image">
                                <img src={ImageConfig.CongratulationImage} alt={'imagePath'}/>
                            </div>
                            <div
                                className="test-order-status-confirmation-dialog-title">
                                {testOrderDetails?.patientDetails?.firstName} {testOrderDetails?.patientDetails?.lastName}
                            </div>
                            <div
                                className="test-order-status-confirmation-dialog-sub-text">
                                <div>{testOrderDetails?.facilityDetails?.name}</div>
                                &nbsp; &nbsp; | &nbsp; &nbsp;
                                <div>{testOrderDetails?.locationDetails?.name}</div>
                            </div>
                            <div className="test-order-status-confirmation-dialog-sub-description">
                                Congratulations! Test Order has been created successfully.
                            </div>
                            <div className="test-order-status-confirmation-dialog-sub-body">
                                <SelectDropdownComponent
                                    name={"size"}
                                    label={'Print Size'}
                                    placeholder={'Select Print Size'}
                                    required={true}
                                    options={LabelOptions}
                                    valueKey={'code'}
                                    getOptionLabel={(option => (option.title) || '')}
                                    onUpdate={(value: string) => {
                                        setLabelSize(value)
                                    }}
                                />
                                {
                                    testOrderSampleList?.map((sample: any, index: number) => {
                                        const sampleName = sample?.orderType === 'test' ? sample?.testDetails?.name : sample?.panelDetails?.name
                                        return <div className="panels-container">
                                            <div className="d-flex">
                                                <TooltipComponent
                                                    placement={'top'}
                                                    tooltip={sampleName}
                                                    arrow={true}>
                                                    <div className="panel-name">{sample.testDetails?.name} </div>
                                                </TooltipComponent>
                                                :
                                            </div>
                                            <TooltipComponent
                                                placement={'top'}
                                                tooltip={sample?.barcode}
                                                arrow={true}>
                                                <div className="barcode">
                                                    {sample?.barcode}
                                                </div>
                                            </TooltipComponent>
                                            <CopyComponent iconOnly content={sample?.barcode}/>
                                            {/*multiple sample have same reference, so store the current barcode to useState*/}
                                            <div ref={printSectionRef} style={{display: 'none'}}>
                                                <div id="print-section">
                                                    <Barcode margin={0} ean128={true}
                                                             height={LabelConfigurations?.[labelSize]?.barcodeHeight}
                                                             fontSize={0}
                                                             value={currentBarCode}/>
                                                    <div className={"print-label-value-wrapper"}>
                                                        <span className="print-label">Barcode:</span>
                                                        <span
                                                            className="print-value">{currentBarCode}</span>
                                                    </div>
                                                    <div className={"print-label-value-wrapper"}>
                                                        <span className="print-label">F.Name:</span>
                                                        <span
                                                            className="print-value">{sample?.orderDetails?.patientDetails?.firstName}</span>
                                                    </div>
                                                    <div className={"print-label-value-wrapper"}>
                                                        <span className="print-label">L.Name:</span>
                                                        <span
                                                            className="print-value">{sample?.orderDetails?.patientDetails?.lastName}</span>
                                                    </div>
                                                    <div className={"print-label-value-wrapper"}>
                                                        <span className="print-label">DOB:</span>
                                                        <span
                                                            className="print-value">{sample?.orderDetails?.patientDetails?.dateOfBirth ? commonService.formatDate(sample?.orderDetails?.patientDetails?.dateOfBirth) : "N/A"}</span>
                                                    </div>
                                                    <div className={"print-label-value-wrapper"}>
                                                        <span className="print-label">DOS:</span>
                                                        <span
                                                            className="print-value">{sample?.dateOfCollection ? commonService.formatDate(sample?.dateOfCollection) : "N/A"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <ButtonComponent
                                                variant={'icon'}
                                                color={'primary'}
                                                className={'mrg-left-15 mrg-right-15'}
                                                handleClick={() => {
                                                    setCurrentBarCode(sample?.barcode)
                                                    setTimeout(() => handlePrint(), 0)
                                                }}
                                                // startIcon={<LocalPrintshopOutlinedIcon/>}
                                                disabled={!labelSize}
                                            >
                                                <LocalPrintshopOutlinedIcon/>
                                            </ButtonComponent>
                                            <PDFFileForRequisition testOrderDetails={testOrderDetails} sampleIndex={index}/>

                                        </div>
                                    })
                                }
                            </div>
                            <div className="test-order-status-confirmation-dialog-sub-actions">
                                <ButtonComponent
                                    color={"primary"}
                                    fullWidth={true}
                                    handleClick={placeTestOrder.bind(null, true)}
                                    isLoading={isPlaceOrderLoading}
                                    variant={"contained"}>
                                    Proceed
                                </ButtonComponent>
                            </div>
                        </div>
                    }
                </DialogComponent>
            </div>
        )

    }

;

export default TestOrderCreationScreen;
